import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const testTypeCategoryLocaleModule: LocaleModule = {
  name: "testTypeCategory",
  messages: { en: en, it: it },
};
